import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
`;

export const Title = styled.h1`
  font-family: Arial, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0;
  text-align: left;
  margin-bottom: 8px;
`;

export const Subtitle = styled.p`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0;
  text-align: left;
  margin-bottom: 16px;
`;

interface SelectedProps {
  selected?: boolean;
}

export const CompanyRow = styled.div<SelectedProps>`
  background: ${({ selected }) => (selected ? 'rgba(0, 240, 255, 0.1)' : '#ffffff')};
  border: 1px solid ${({ selected }) => (selected ? '#1b7ef9' : '#cccccc')};
  box-sizing: border-box;
  border-radius: 4px;
  height: 48px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;

  &:last-of-type {
    margin-bottom: 40px;
  }
`;

export const Checkbox = styled.img.attrs<SelectedProps>(({ selected }) => ({
  src: selected ? 'img/radio_selected.svg' : 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
}))<SelectedProps>`
  margin-right: 15px;
  width: 16px;
  height: 16px;
  padding: 2px;
  background: #e7e7e7;
  border-radius: 50%;
  border: 1px solid #cccccc;
`;

export const Label = styled.span`
  display: flex;
  flex: 1;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0;
  text-align: left;
`;

export const Icon = styled.img`
  height: 100%;

  @media (max-width: 375px) {
    max-height: 16px;
  }
`;
